import {useEffect, useState} from "react";

import {useUserDevice} from "@pg-mono/user-device";

import {DEFAULT_ACTIVATION_DELAY} from "../constants/general";
import {useOnScreenObserver} from "./use_on_screen_observer";

interface Props {
    shouldOpenAfterActivationOnMobile?: boolean;
    shouldOpenAfterActivationOnDesktop?: boolean;
    activationDelay?: number;
    onClose?: (closedFromContent: boolean) => void;
    onOpen?: () => void;
    openTriggerSectionId?: string;
}

export const useFeedbackPopup = (props: Props = {}) => {
    const {isMobile} = useUserDevice();
    const activationDelay = props.activationDelay ?? DEFAULT_ACTIVATION_DELAY;

    const [isActivate, setIsActivate] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isTriggerPromptActive, setIsTriggerPromptActive] = useState(false);
    const [hasBeenInitialized, setHasBeenInitialized] = useState(false);

    const {isOnScreen, startObserver, stopObserver} = useOnScreenObserver(props.openTriggerSectionId);

    useEffect(() => {
        if (!isMobile && props.openTriggerSectionId && !hasBeenInitialized) {
            startObserver();
        }
    }, [props.openTriggerSectionId, isMobile]);

    useEffect(() => {
        if (activationDelay === -1 || (props.openTriggerSectionId && !isMobile)) {
            return;
        }

        const timeout = setTimeout(() => {
            if (hasBeenInitialized) {
                return;
            }

            setIsActivate(true);

            if ((isMobile && props.shouldOpenAfterActivationOnMobile) || (!isMobile && props.shouldOpenAfterActivationOnDesktop)) {
                setIsOpen(true);
            } else {
                setIsTriggerPromptActive(true);
            }
        }, activationDelay);

        return () => {
            clearTimeout(timeout);
        };
    }, [isMobile, hasBeenInitialized]);

    useEffect(() => {
        if (isOpen) {
            setHasBeenInitialized(true);

            // Show notification only once - hide after first open
            setIsTriggerPromptActive(false);
        }
    }, [isOpen]);

    useEffect(() => {
        if (isOnScreen && !isOpen && !hasBeenInitialized) {
            onOpen();
            stopObserver();
        }
    }, [isOnScreen, isOpen, hasBeenInitialized]);

    const onOpen = () => {
        setIsOpen(true);
        props.onOpen?.();
    };

    const onClose = (closedFromContent = false) => {
        setIsOpen(false);
        props.onClose?.(closedFromContent);
    };

    return {
        hasBeenInitialized,
        isOpen,
        setIsOpen,
        feedbackPopupProps: {
            isActivate,
            hasBeenInitialized,
            isOpen,
            isTriggerPromptActive,
            onOpen,
            onClose
        }
    };
};
import {useEffect, useState} from "react";

import {useUserDevice} from "@pg-mono/user-device";

import {DEFAULT_ACTIVATION_DELAY} from "../constants/general";
import {useOnScreenObserver} from "./use_on_screen_observer";

interface Props {
    shouldOpenAfterActivationOnMobile?: boolean;
    shouldOpenAfterActivationOnDesktop?: boolean;
    activationDelay?: number;
    onClose?: (closedFromContent: boolean) => void;
    onOpen?: () => void;
    openTriggerSectionId?: string;
}

export const useFeedbackPopup = (props: Props = {}) => {
    const {isMobile} = useUserDevice();
    const activationDelay = props.activationDelay ?? DEFAULT_ACTIVATION_DELAY;

    const [isActivate, setIsActivate] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isTriggerPromptActive, setIsTriggerPromptActive] = useState(false);
    const [hasBeenInitialized, setHasBeenInitialized] = useState(false);

    const {isOnScreen, startObserver, stopObserver} = useOnScreenObserver(props.openTriggerSectionId);

    useEffect(() => {
        if (!isMobile && props.openTriggerSectionId && !hasBeenInitialized) {
            startObserver();
        }
    }, [props.openTriggerSectionId, isMobile]);

    useEffect(() => {
        if (activationDelay === -1 || (props.openTriggerSectionId && !isMobile)) {
            return;
        }

        const timeout = setTimeout(() => {
            if (hasBeenInitialized) {
                return;
            }

            setIsActivate(true);

            if ((isMobile && props.shouldOpenAfterActivationOnMobile) || (!isMobile && props.shouldOpenAfterActivationOnDesktop)) {
                setIsOpen(true);
            } else {
                setIsTriggerPromptActive(true);
            }
        }, activationDelay);

        return () => {
            clearTimeout(timeout);
        };
    }, [isMobile, hasBeenInitialized]);

    useEffect(() => {
        if (isOpen) {
            setHasBeenInitialized(true);

            // Show notification only once - hide after first open
            setIsTriggerPromptActive(false);
        }
    }, [isOpen]);

    useEffect(() => {
        if (isOnScreen && !isOpen && !hasBeenInitialized) {
            onOpen();
            stopObserver();
        }
    }, [isOnScreen, isOpen, hasBeenInitialized]);

    const onOpen = () => {
        setIsOpen(true);
        props.onOpen?.();
    };

    const onClose = (closedFromContent = false) => {
        setIsOpen(false);
        props.onClose?.(closedFromContent);
    };

    return {
        hasBeenInitialized,
        isOpen,
        setIsOpen,
        feedbackPopupProps: {
            isActivate,
            hasBeenInitialized,
            isOpen,
            isTriggerPromptActive,
            onOpen,
            onClose
        }
    };
};
